import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ModalController , ItemSliding } from 'ionic-angular';

import { OperadorPackingPage } from '../operador-packing/operador-packing';
import { OperadorPedidosPage } from '../operador-pedidos/operador-pedidos';

import { Tools, User, Api } from '../../providers';

@IonicPage()
@Component({
  selector: 'page-adiantador-operacao',
  templateUrl: 'adiantador-operacao.html',
})
export class AdiantadorOperacaoPage {

  nav:string='0';
  progress:string='0';
  pedidosNome:any;
  produtosPendentes:any=[];
  produtosConcluidos:any=[];
  produtosCancelados:any=[];
  pedido:any={
    pedidosId:[],
    items:[]
  };
  postObj:any={};
  separacaoLocal:any={};

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    private api:Api,
    public user: User,
    private tools:Tools
  ){}

  ionViewDidLoad(){
    console.log('ionViewDidLoad OperadorOperacaoPage');
    this.pedido = this.navParams.get('item');
    console.log(this.pedido);

    var nomes = this.pedido.items.map(e=>e.codigo);
    this.pedidosNome = nomes.filter(function(item, pos){
      return nomes.indexOf(item) == pos;
    });
    this.calcProgress();

    this.pedido.items = this.pedido.items.map(e=>{
      e.statusColor = 'white'
      return e;
    });

    var codigos = this.pedido.items.map(e=>e.codigoBarra);

    var codigosLimpos = codigos.filter((item, pos) => { return codigos.indexOf(item) == pos; });

    this.buscarProdutos(codigosLimpos);
  }

  buscarProdutos(codigosBarra){
    var loading = this.tools.showLoading('Carregando');
    loading.present();

    let self = this;
    var urlBuscarProdutos = 'http://barbosa.ibrs.com.br:5000/api/tracking/buscarprodutosimg';

    this.postObj = {codigos:codigosBarra};

    this.sendPost(urlBuscarProdutos,(result)=>{
      console.log(result);

      if(result.status && result.data && result.data.length>0){

        //Vincular categoria (ja faz na tela anterior)
        // for(var x1 in result.produtos){
        //   var produtoBase = result.produtos[x1];
        //   var prodCategoria = this.pedido.items.find(f=>f.codigoBarra == produtoBase.sku);
        //
        //   if(prodCategoria){
        //     prodCategoria.categoria = result.produtos.find(e => e.sku == prodCategoria.codigoBarra).categoria;
        //     prodCategoria.categoriaSecundaria = result.produtos.find(e => e.sku == prodCategoria.codigoBarra).categoriaSecundaria;
        //     prodCategoria.departamento = result.produtos.find(e => e.sku == prodCategoria.codigoBarra).departamento;
        //   }else{
        //     console.log('Produto não encontrado na base brainProdutos: ', result.produtos[x1]);
        //   }
        // }

        //Vincular imagem
        for(var x1 in result.data){
          var prod = this.pedido.items.find(f=>f.codigoBarra == result.data[x1].sku);

          if(prod && result.data[x1].linkId){
            prod.img = `http://barbosa.ibrs.com.br:4032/gridfs/${this.user.getSession()}/download/fileProdutos/${result.data[x1].linkId}/-1`;
            // console.log(`http://barbosa.ibrs.com.br:4032/gridfs/${this.user.getSession()}/download/fileProdutos/${result.data[x1].linkId}/-1`);
          }
        }

        //Filtrar Produtos Açougue
        var categoriasAcougue = ['BOVINOS', 'AVES', 'SUINOS'];
        this.pedido.items = this.pedido.items.filter(e => categoriasAcougue.indexOf(e.categoria) >= 0);

        setTimeout(() => {
          loading.dismiss();
        }, 500);

      }else{
        self.tools.showAlert('toast',`${result.msg}`,1500);
        loading.dismiss();
      }
    });
  }

  sendPost(url,callback){
    var self = this;
    this.api.sendPost(url,self.postObj,{},function(result){
      callback(result);
    });
  }

  calcProgress(){
    this.progress = ((100*this.produtosConcluidos.length/this.pedido.items.filter(e=>!e.cancelado).length)+'').split('.')[0];
  }

  showPedidos(){
    const alert = this.alertCtrl.create({
      title: `Separação: ${this.pedido.codigo}`,
      subTitle: `${this.pedidosNome.join(', ')}`,
      buttons: ['OK']
    });
    alert.present();
  }

  // ionViewCanLeave(): boolean{
  //   console.log('entrou');
  //   let loading = this.tools.showLoading('Conectando...');
  //   loading.present();
  //   this.navCtrl.setRoot(OperadorPedidosPage,{item:loading});
  //
  //   return true;
  // }

  openPack(item,type){
    var idx = this.pedido.items.findIndex(e=>e.codigo == item.codigo && e.codigoBarra == item.codigoBarra);

    let modal = this.modalCtrl.create(OperadorPackingPage,{separacao:this.pedido, idx:idx, caixas:this.pedido.caixas});
    modal.present();

    var self = this;

    modal.onDidDismiss(items => {
      console.log(items);

      if(items && items.length>0){
        this.pedido.items = items;

        this.tools.storage('load','separacao',null,(e)=>{
          console.log(e);

          if(e.status){
            this.separacaoLocal = JSON.parse(e.data);

            if(this.separacaoLocal.codigo != this.pedido.codigo){
              this.tools.showAlert('toast','Pedido Diferente No LS, Mudando');
              this.separacaoLocal = this.pedido;
            }else{
              this.separacaoLocal.items = this.pedido.items;
            }

            this.separacaoLocal.timeupd = new Date().getTime();

            self.tools.storage('save','separacao',JSON.stringify(this.separacaoLocal),(resultS) => {
              if(resultS.status){
                self.tools.showAlert('toast','Pedido LS Atualizado');
              }
            });

          }else{
            this.tools.showAlert('toast','Erro ao salvar LS');
          }

        });

      }
      this.calcProgress();
    });
  }

  finalizar(){
    var loading = this.tools.showLoading('Carregando');
    loading.present();

    var url = 'http://barbosa.ibrs.com.br:5000/api/tracking/finalizarsep';

    var postObj = {
      "app_key":"rtEVWH9FSjx6KoUxMxuN0uC6",
      "app_secret":"4rEyQRcvb0P4",
      "separacaoId":this.pedido._id+''
    }

    let self = this;
    this.api.sendPost(url,postObj,{},function(result){
      console.log('result: ',result)
      if(result.status){
        self.tools.storage('del','separacao',null,(e)=>{
          console.log(e);
          self.navCtrl.setRoot(OperadorPedidosPage,{item:loading});
          self.tools.showAlert('toast',result.msg);
        });
      }else{
        self.tools.showAlert('toast',result.msg);
        loading.dismiss();
      }
    });
  }

  delete(slidingItem: ItemSliding, item:any){
    console.log('delete');
    console.log(slidingItem);
    console.log(item);

    let confirm = this.alertCtrl.create({
      title: 'Confirmação',
      message: 'Deseja realmete remover o produto ?',
      buttons: [
        { text: 'Não', handler: () => { slidingItem.close(); } },
        {
          text: 'Sim',
          handler: () => {
            item.statusColor = 'lightcoral';
            slidingItem.close();
          }
        }
      ]
    });
    confirm.present();
  }

  confirm(slidingItem: ItemSliding, item:any) {
    console.log('confirm');
    console.log(slidingItem);
    console.log(item);
    item.statusColor = 'lightblue';
    setTimeout(() => {
      slidingItem.close();
    }, 100);
  }

}



// WEBPACK FOOTER //
// ./src/pages/adiantador-operacao/adiantador-operacao.ts